import { Divider } from 'antd';
import { Icon } from '../../../components/icon/icon';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { capitalize } from 'lodash';
import ButtonIconOutlineMedium from '../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { DetailProductPageContext } from '../DetailProductPageUpgrage';
import { isEmpty } from '../../../utils/data/list.utils';

const SectionSummary = () => {
  const { variant, setVariant } = useContext(DetailProductPageContext);

  const { t } = useTranslation();
  const { detail } = useSelector(state => state.saleProduct);
  const [item, setItem] = useState();

  useEffect(() => {
    setItem({ ...(detail.data ?? {}) });
  }, [detail]);

  if (
    (!item?.sizes || isEmpty(item.sizes)) &&
    (!item?.planks || isEmpty(item.planks)) &&
    (!item?.textures || isEmpty(item.textures))
  )
    return <></>;
  return (
    <section className="lg:grid lg:grid-cols-3 flex flex-col items-start self-stretch lg:py-[32px] lg:px-[80px] p-[16px] md:px-[20px] gap-[16px] lg:gap-[8px]">
      <RenderSummarySize item={item} />
      <RenderSummaryPlank item={item} />
      <RenderSummaryTexture item={item} />
    </section>
  );
};

export default SectionSummary;

const RenderSummarySize = ({ item }) => {
  const { variant, setVariant } = useContext(DetailProductPageContext);
  const { t } = useTranslation();

  const [sizeCabinet, setSizeCabinet] = useState([]);
  const [sizeStone, setSizeStone] = useState([]);

  useEffect(() => {
    const tempSizeCb = [];
    const tempSizeSTone = [];
    let sizes = [];
    if (Array.isArray(item?.sizes)) {
      sizes = item.sizes?.map(size => [size.name, size.value]) ?? [];
    } else {
      sizes =
        Object.entries(item?.sizes ?? {})?.filter(([, value]) => value) ?? [];
    }
    sizes
      .filter(([key]) => !['backsplash', 'countertop'].includes(key))
      .forEach(([key, value]) => {
        tempSizeCb.push({ key, value });
      });
    // const base = sizes.find(item => item[0] === 'base');
    // const upper = sizes.find(item => item[0] === 'upper');
    // const ceiling = sizes.find(item => item[0] === 'ceiling');
    const backsplash = sizes.find(item => item[0] === 'backsplash');
    const countertop = sizes.find(item => item[0] === 'countertop');

    // const depth = sizes.find(item => item[0] === 'depth');
    // const height = sizes.find(item => item[0] === 'height');
    // const length = sizes.find(item => item[0] === 'length');

    // if (depth) {
    //   tempSizeCb.push({ key: 'depth', value: depth[1] });
    // }
    // if (height) {
    //   tempSizeCb.push({ key: 'height', value: height[1] });
    // }
    // if (length) {
    //   tempSizeCb.push({ key: 'length', value: length[1] });
    // }

    // if (base) {
    //   tempSizeCb.push({ key: 'base', value: base[1] });
    // }
    // if (upper) {
    //   tempSizeCb.push({ key: 'upper', value: upper[1] });
    // }
    // if (ceiling) {
    //   tempSizeCb.push({ key: 'ceiling', value: ceiling[1] });
    // }
    if (backsplash) {
      tempSizeSTone.push({ key: 'backsplash', value: backsplash[1] });
    }
    if (countertop) {
      tempSizeSTone.push({ key: 'countertop', value: countertop[1] });
    }
    setSizeCabinet(tempSizeCb);
    setSizeStone(tempSizeSTone);
  }, [item]);

  useEffect(() => {
    if (variant) {
      const sizes = variant.value?.split(';') ?? [];
      if (sizes.length === 2) {
        setSizeCabinet([
          { key: 'Nệm', value: sizes[0] },
          { key: 'Kích thước phủ bì', value: sizes[1] },
        ]);
      }
    }
  }, [variant]);

  if (!sizeCabinet.length && !sizeStone.length) return <></>;
  return (
    <div className="flex p-[24px] flex-col items-start gap-[16px] grow self-stretch bg-white rounded-[16px]">
      <div className="flex h-[32px] items-center gap-[12px] self-stretch">
        <span className="w-[24px] h-[24px] flex">
          <Icon.ICRuler />
        </span>
        <span className="text-title-medium">{t('Size')}</span>
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
      <div className="grid grid-cols-2 items-start gap-y-[16px] gap-x-[8px] self-stretch">
        {sizeCabinet.map((size, i) => (
          <div
            key={i}
            className="flex flex-col gap-8 items-start text-label-medium font-semibold"
          >
            <span className="text-black-medium text-label-medium">
              {t(getValueFromString(capitalize(size.key)))}
            </span>
            <span className="text-black-high text-body-medium">
              {size.value} mm
            </span>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 items-start gap-y-[16px] gap-x-[8px] self-stretch">
        {sizeStone.map((size, i) => (
          <div
            key={i}
            className="flex flex-col gap-8 items-start text-label-medium font-semibold"
          >
            <span className="text-black-medium text-label-medium">
              {t(getValueFromString(capitalize(size.key)))}
            </span>
            <span className="text-black-high text-body-medium !font-semibold">
              {size.value} mm
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const RenderSummaryPlank = ({ item }) => {
  const { t } = useTranslation();

  if (
    (!item?.planks || isEmpty(item.planks)) &&
    (!item?.textures || isEmpty(item.textures))
  )
    return <></>;
  return (
    <div className="flex p-[24px] flex-col items-start gap-[16px] grow self-stretch bg-white rounded-[16px]">
      <div className="flex h-[32px] items-center gap-[12px] self-stretch">
        <span className="w-[24px] h-[24px] flex">
          <Icon.ICStack />
        </span>
        <span className="text-title-medium">{t('Plank')}</span>
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
      <div className="grid grid-cols-2 items-start gap-y-[16px] gap-x-[8px] self-stretch">
        {(() => {
          if (item?.textures && !Array.isArray(item?.textures)) {
            const getType = type => {
              return type === 'M'
                ? t('Melamine-coated MDF')
                : type === 'L'
                  ? t('Moisture-resistant MDF')
                  : type;
            };
            const types = [];
            const suppliers = [];
            item.textures.door?.forEach(item => {
              const supplier = item.supplier;
              const type = supplier?.materialType;
              if (!types.includes(type)) {
                types.push(type);
              }
              if (
                supplier &&
                !suppliers.find(item => item.id === supplier.id)
              ) {
                suppliers.push(supplier);
              }
            });
            item.textures.frame?.forEach(item => {
              const supplier = item.supplier;
              const type = supplier?.materialType;
              if (!types.includes(type)) {
                types.push(type);
              }
              if (
                supplier &&
                !suppliers.find(item => item.id === supplier.id)
              ) {
                suppliers.push(supplier);
              }
            });

            let result;
            types.forEach(item => {
              if (result) {
                result = result + ', ' + getType(item);
              } else result = getType(item);
            });

            if (result)
              return (
                <>
                  <div className="flex flex-col gap-[8px] items-start text-label-medium font-semibold">
                    <span className="text-black-medium text-label-medium">
                      {t('Panel type')}
                    </span>
                    <span className="text-black-high text-body-medium !font-semibold">
                      {result}
                    </span>
                  </div>
                  <div className="flex flex-col gap-[8px] items-start text-label-medium font-semibold">
                    <span className="text-black-medium text-label-medium">
                      {t('Supplier')}
                    </span>
                    <span className="text-black-high text-body-medium !font-semibold">
                      {suppliers.map(item => item.name).join(', ')}
                    </span>
                  </div>
                </>
              );
          }
        })()}

        {Array.isArray(item?.planks)
          ? item?.planks.map((plank, i) => (
              <div
                key={i}
                className="flex flex-col gap-8 items-center text-label-medium font-semibold"
              >
                <span className="text-black-medium">
                  {t(getValueFromString(plank.name))}
                </span>
                <span className="text-black-high">{plank.value} mm</span>
              </div>
            ))
          : Object.entries(item?.planks ?? {}).map(([key, value], i) => (
              <div
                key={i}
                className="flex flex-col gap-8 items-start text-label-medium font-semibold"
              >
                <span style={{ color: '#5A5D60' }}>{t(capitalize(key))}</span>
                <span className="text-black-high">{value} mm</span>
              </div>
            ))}
      </div>
    </div>
  );
};

const RenderSummaryTexture = ({ item }) => {
  const { t } = useTranslation();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [textureCabinet, setTextureCabinet] = useState([]);
  const containerRef = useRef(null);

  const scrollToGroup = index => {
    const container = containerRef.current;
    const target = container?.querySelector(`#group_texture_${index}`);
    if (target && container) {
      // targetLeft = vị trí hiện tại của element so với cạnh trái container
      const targetLeft =
        target.getBoundingClientRect().left -
        container.getBoundingClientRect().left;
      // Cộng thêm scrollLeft hiện tại để ra vị trí tuyệt đối cần scroll đến
      container.scrollTo({
        left: container.scrollLeft + targetLeft,
        behavior: 'smooth',
      });
    }
  };

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;
    const containerLeft = container.getBoundingClientRect().left;
    const groups = container.querySelectorAll('[id^="group_texture_"]');
    let closestIndex = 0;
    let closestDistance = Infinity;
    groups.forEach((el, i) => {
      const elLeft = el.getBoundingClientRect().left - containerLeft;
      // Chỉ xét element có cạnh trái >= 0 (nằm trong container)
      // và tìm cái gần cạnh trái nhất
      if (elLeft >= 0 && elLeft < closestDistance) {
        closestDistance = elLeft;
        closestIndex = i;
      }
    });
    setCurrentIndex(closestIndex);
  };

  useEffect(() => {
    const tempTextureCb = [];

    let textures = [];
    if (Array.isArray(item?.textures)) {
      textures =
        item.textures?.map(texture => {
          return [
            texture.name,
            [
              {
                textureCode: texture.code,
                supplier: texture.supplier,
                textureUrl: texture.image,
              },
            ],
          ];
        }) ?? [];
    } else {
      textures =
        Object.entries(item?.textures ?? {})
          .filter(([key, value]) => value?.length)
          ?.map(([key, value]) => [
            key,
            [
              ...value.map(texture => ({
                textureCode: texture.code,
                supplier: texture.supplier?.name,
                textureUrl: texture.textureUrl,
              })),
            ],
          ]) ?? [];
    }

    if (item?.items && item.items['Backsplash']) {
      textures.push([
        'Backsplash',
        [
          ...item.items['Backsplash'].map(texture => ({
            ...texture,
            textureCode: texture.texture,
            supplier: texture.supplier?.name,
          })),
        ],
      ]);
    }
    if (item?.items && item.items['Countertop']) {
      textures.push([
        'Countertop',
        [
          ...item.items['Countertop'].map(texture => ({
            ...texture,
            textureCode: texture.texture,
            supplier: texture.supplier?.name,
          })),
        ],
      ]);
    }

    textures.forEach(([key, value]) => {
      tempTextureCb.push({ key, value });
    });
    setTextureCabinet(tempTextureCb);
  }, [item]);

  if (!textureCabinet.length) return <></>;

  return (
    <div className="flex p-[24px] flex-col items-start gap-[16px] grow self-stretch bg-white rounded-[16px]">
      <div className="flex justify-between items-center self-stretch">
        <div className="flex h-[32px] items-center gap-[12px] self-stretch">
          <span className="w-[24px] h-[24px] flex">
            <Icon.ICPalette />
          </span>
          <span className="text-title-medium">{t('Color')}</span>
        </div>
        <div className="flex items-center gap-[8px]">
          <ButtonIconOutlineMedium
            icon={<Icon.ICNavigateBefore />}
            disabled={currentIndex === 0}
            onClick={() => {
              if (currentIndex > 0) {
                scrollToGroup(currentIndex - 1);
                setCurrentIndex(prev => prev - 1);
              }
            }}
          />
          <ButtonIconOutlineMedium
            icon={<Icon.ICNavigateNext />}
            disabled={currentIndex === textureCabinet?.length - 1}
            onClick={() => {
              if (currentIndex < textureCabinet?.length - 1) {
                scrollToGroup(currentIndex + 1);
                setCurrentIndex(prev => prev + 1);
              }
            }}
          />
        </div>
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
      <div
        ref={containerRef}
        onScroll={handleScroll}
        className="flex items-start gap-y-[16px] gap-x-[8px] self-stretch overflow-x-auto [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar-thumb]:hidden"
      >
        {textureCabinet?.map((item, i) => {
          return (
            <div
              key={i}
              id={'group_texture_' + i}
              className="flex flex-col gap-8 items-start self-stretch"
            >
              <span className="text-label-medium text-black-medium">
                {t(capitalize(item.key))}
              </span>
              <div className="flex items-center gap-8 self-stretch">
                {item.value.map((texture, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-start rounded-[4px]"
                    style={{
                      width: '124px',
                      border: '1px solid #F4F4F4',
                    }}
                  >
                    <div className="flex items-center gap-8 self-stretch">
                      <img
                        src={texture.textureUrl}
                        alt=""
                        className="h-60 rounded-[2px] object-fit-fill grow border-[1px] border-solid border-outline-default-primary"
                      />
                    </div>
                    <div className="flex p-8 flex-col items-start gap-0 self-stretch">
                      <span className="text-body-small text-black-high !font-semibold">
                        {texture.textureCode}
                      </span>
                      {texture.supplier ? (
                        <span className="text-body-small text-black-low">
                          {getValueFromString(texture.supplier)}
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
